import React from 'react';

function StatsCard({ sessionStats, navigate }) {
  return (
    <div style={cardStyle}>
      <div style={cardHeaderStyle}>
        <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Billing Stats</div>
      </div>
      <div style={cardBodyStyle}>
        <div style={statsGridStyle}>
          <div style={statsBoxStyle}>
            <div style={statTitleStyle}>No Shows</div>
            <div style={{
              ...statValueStyle,
              color: sessionStats.noShowWeekCount === 0 ? '#10B981' :
                     sessionStats.noShowWeekCount <= 2 ? '#F59E0B' :
                     '#EF4444'
            }}>
              {sessionStats.noShowWeekCount} | {sessionStats.noShowMonthCount}
            </div>
            <div style={statSubtextStyle}>Weekly | Monthly</div>
          </div>

          <div style={statsBoxStyle}>
            <div style={statTitleStyle}>Cancellations</div>
            <div style={{
              ...statValueStyle,
              color: sessionStats.cancelWeekCount === 0 ? '#10B981' :
                     sessionStats.cancelWeekCount <= 3 ? '#F59E0B' :
                     '#EF4444'
            }}>
              {sessionStats.cancelWeekCount} | {sessionStats.cancelMonthCount}
            </div>
            <div style={statSubtextStyle}>Weekly | Monthly</div>
          </div>

          <div
            style={{ ...statsBoxStyle, cursor: 'pointer' }}
            onClick={() => navigate('/therapist/debt')}
            title="View debt records"
          >
            <div style={statTitleStyle}>Debts</div>
            <div style={{
              ...statValueStyle,
              color: sessionStats.debtCount === 0 ? '#10B981' : '#EF4444'
            }}>
              {sessionStats.debtCount}
            </div>
            <div style={statSubtextStyle}>${sessionStats.debtTotal.toFixed(2)}</div>
          </div>

          <div style={statsBoxStyle}>
            <div style={statTitleStyle}>Weekly Avg</div>
            <div style={{ ...statValueStyle, color: '#3B82F6' }}>
              {sessionStats.monthlyAvgCount}
            </div>
            <div style={statSubtextStyle}>Last 4 weeks</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const cardStyle = {
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 1px 8px rgba(0,0,0,0.09)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

const cardHeaderStyle = {
  background: '#1D2C5F',
  padding: '14px 20px',
};

const cardBodyStyle = {
  padding: '18px 20px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
};

const statsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',
  flex: 1,
};

const statsBoxStyle = {
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: '#F5F3EF',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const statTitleStyle = {
  fontSize: '0.8rem',
  fontWeight: 700,
  color: '#878DA1',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  marginBottom: '6px',
};

const statValueStyle = {
  fontSize: '1.5rem',
  fontWeight: 'bold',
};

const statSubtextStyle = {
  fontSize: '0.75rem',
  color: '#6B7280',
  marginTop: '4px',
};

export default StatsCard;
